<template>
    <el-dialog append-to-body :visible.sync="showTag" width="40%" title="选择时间段">
        <el-table :data="list" size="mini" border style="width: 100%">
            <el-table-column label="序号" prop="sortNumber"></el-table-column>
            <el-table-column label="时段">
                <template slot-scope="{row}">
                    <span>{{row.timeIntervalStartTime}}~{{row.timeIntervalEndTime}}</span>
                </template>
            </el-table-column>
            <el-table-column label="预约状态">
                <template slot-scope="{row}">
                    <div class="flex aic">
                        <span class="icon mr5" :class="[getIconColor(row.bookedStatus)]"></span>
                        <span>{{row.bookedStatus?'已预约':'未预约'}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="预约人">
                <template slot-scope="{row}">
                    <span v-if="row.bookedStatus">{{row.healthcheckerName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="!row.bookedStatus" type="text" size="mini" @click="sub(row)">预约
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
  import {DiaLogMixin} from "../../../common/lib/mixins/dialog-base";
  import {healthcheckService} from "../services/healthcheck";
  import dayjs from 'dayjs';

  export default {
    name: "dialog-number",
    mixins: [DiaLogMixin],
    data() {
      return {
        list: [],
        curr: new Date()
      }
    },
    methods: {
      open(data) {
        this.show();
        this.curr = data;
        this.getData();
      },
      getIconColor(status) {
        if (!status) return 'bg_red';
        return 'bg_main';
      },
      sub(data) {
        this.$emit('yuyue', data);
        this.hide();
      },
      async getData() {
        const date = dayjs(this.curr).format('YYYY-MM-DD');
        //this.list = await healthcheckService.tjhyDate(date);
        this.list = await healthcheckService.tjhyDateAll({
          date, bookedTeamId: this.healthcheckBookTeam.id
        });
      },
    },
  }
</script>

<style scoped>
    .icon {
        border-radius: 50%;
        width: 4px;
        height: 4px;
    }
</style>
